import React from 'react';

export default function FontPreviewCard({ font, active, onSelect }) {
  return (
    <button
      type="button"
      className={`mp-font-picker-card ${active ? 'is-active' : ''}`}
      onClick={() => onSelect(font)}
    >
      <p className="mp-font-picker-card__sample" style={{ fontFamily: `'${font.family}', sans-serif` }}>
        Aa Bb Cc
      </p>
      <strong className="mp-font-picker-card__family">{font.family}</strong>
      <small className="mp-font-picker-card__category">{font.category}</small>
    </button>
  );
}
